export default __webpack_public_path__ + "static/media/NYA-CAKE.625e3b81.svg";